module.exports = __webpack_public_path__ + "static/help-c16f0b721a4850859b544c8a65d96c6f.png";